module.exports = __webpack_public_path__ + "img/7_152.42ad2d28.png";